import { InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { KeyboardEventHandler, ReactElement } from "react";

export interface Props {
  placeholder?: string;
  onChange?: TextFieldProps["onChange"];
  onKeyUp?: KeyboardEventHandler<HTMLInputElement>;
  startAdornment?: ReactElement;
}

export const AutocompleteField = ({
  placeholder,
  onChange,
  onKeyUp,
  startAdornment,
}: Props) => {
  return (
    <TextField
      data-testid="values-search-input"
      autoComplete="off"
      color="primary"
      placeholder={placeholder}
      size="small"
      onChange={onChange}
      onKeyUp={onKeyUp}
      sx={{
        width: "100%",
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderWidth: "1px !important",
        },
      }}
      slotProps={{
        input: {
          sx: {
            bgcolor: "code.background",
            m: 3,
            mb: 0,
            px: 1,
          },
          startAdornment: startAdornment || (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: "24px" }} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
